/**
 * Albanian lek.
 */
export var ALL = {
  code: 'ALL',
  base: 10,
  exponent: 2
};